import { Grid } from "@mui/material";
import { useEffect } from "react";
import moduleLayoutStyles from "./Styles/moduleLayout.module.css";
import Alarm from "../../images/Alarm.svg";
import Analyze from "../../images/Analyze.svg";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../../Hooks/stateProvider";
import { ls } from "../../variables";
import { LightTooltip } from "../../components/LightTooltip";

const ModulesLayout = () => {
  const navigate = useNavigate();
  const [{ moduleType }, dispatch] = useStateValue();
  let onHandler = (value) => {
    if (value == "/app/hytrLayout") {
      // dispatch({ type: "moduleType", moduleType: "HYTR" });
    }
    navigate(value);
  };

  const reportType = ls.get("reportType");
  const userType = ls.get("userType");

  useEffect(() => {
    dispatch({ type: "fy_year", fy_year: "" });
    dispatch({ type: "quarter", quarter: "" });
    // dispatch({ type: "half_year", half_year: "" });
    dispatch({ type: "pmsname", pmsname: "" });
    dispatch({ type: "moduleType", moduleType: "" });
    userType == "SEBI" && dispatch({
      type: "SET_OpenNestedList",
      pmsOpenNestedList: {
        localCMMTypeData: ["Compliance Reporting Category 1"],
        localRemarksData: [],
        localStatusData: ["open (sebi)"],
        localGuidanceData: [],
        localQuarterData: ['Q1'],
      },
    });
  }, []);


  return userType == "PMS" ? 
  (
    <Grid container className={moduleLayoutStyles.mainContent}>
      <Grid
        item
        xs={12}
        className={moduleLayoutStyles.welcomeContent}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <h1>Welcome Back!</h1>
      </Grid>
      <Grid
        item
        lg={6}
        xs={12}
        sm={6}
        md={4}
        sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
        onClick={
          reportType.includes("Alert Processing")
            ? () => {
              dispatch({ type: "moduleType", moduleType: "ALERT" });
              dispatch({
                type: "SET_OpenNestedList",
                pmsOpenNestedList: {
                  localCMMTypeData: ["Compliance Reporting Category 1"],
                  localRemarksData: [],
                  localStatusData: ["open", "pending"],
                  localGuidanceData: [],
                },
              });
              onHandler("/app/upload");
            }
            : undefined
        }
      >
        <LightTooltip
          title={
            !reportType.includes("Alert Processing")
              ? "You do not have access to Alert. Please contact Admin."
              : ""
          }
          placement="top"
        >
          <div className={moduleLayoutStyles.boxContainer}>
            <img
              src={Alarm}
              alt="Alert Logo"
              className={moduleLayoutStyles.moduleImg}
            />
            <h3 className={moduleLayoutStyles.moduleName}>Alert Module</h3>
          </div>
        </LightTooltip>
      </Grid>

      <Grid
        item
        lg={6}
        xs={12}
        sm={6}
        md={4}
        sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
        onClick={
          reportType.includes("CMM")
            ? () => {
              dispatch({ type: "moduleType", moduleType: "CMM" });
              dispatch({
                type: "SET_OpenNestedList",
                pmsOpenNestedList: {
                  localCMMTypeData: ["Compliance Reporting Category 1"],
                  localRemarksData: [],
                  localStatusData: ["open"],
                  localGuidanceData: [],
                },
              });
              navigate("/app/cmmLayout");
            }
            : undefined
        }
      >
        <LightTooltip
          title={
            !reportType.includes("CMM")
              ? "You do not have access to CMM. Please contact Admin."
              : ""
          }
          placement="top"
        >
          <div disabled className={moduleLayoutStyles.boxContainer}>
            <img
              src={Analyze}
              alt="CMM Logo"
              className={moduleLayoutStyles.moduleImg}
            />
            <h3 className={moduleLayoutStyles.moduleName}>CMM Module</h3>
          </div>
        </LightTooltip>
      </Grid>
      
    </Grid>
  ) : (
    <>
      <Grid container className={moduleLayoutStyles.mainContent}>
        <Grid
          item
          xs={12}
          className={moduleLayoutStyles.welcomeContent}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1>Welcome Back!</h1>
        </Grid>
        {/* <Grid
          item
          lg={2}
          xs={12}
          sm={6}
          md={6}
          sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
          onClick={() => onHandler("/app/generalModule")}
        >
          <LightTooltip title={!reportType['quicksight']?.length>0 ? "You do not have access to Report Generator. Please contact Admin." : ""} placement="top">
          <div className={moduleLayoutStyles.boxContainer}>
            <img
              src={generalLogo}
              alt="General Module Logo"
              className={moduleLayoutStyles.moduleImg}
            />
            <h3 className={moduleLayoutStyles.moduleName}>General</h3>
          </div>
          </LightTooltip>
        </Grid> */}
        <Grid
          item
          lg={6}
          xs={12}
          sm={6}
          md={6}
          sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
          onClick={
            reportType["Alert Processing"]?.length > 0
              ? () => {
                dispatch({ type: "moduleType", moduleType: "ALERT" });
                onHandler("/app/sebiTracker");
              }
              : undefined
          }
        >
          <LightTooltip
            title={
              !reportType["Alert Processing"]?.length > 0
                ? "You do not have access to Alert. Please contact Admin."
                : ""
            }
            placement="top"
          >
            <div className={moduleLayoutStyles.boxContainer}>
              <img
                src={Alarm}
                alt="Alert Logo"
                className={moduleLayoutStyles.moduleImg}
              />
              <h3 className={moduleLayoutStyles.moduleName}>Alert Module</h3>
            </div>
          </LightTooltip>
        </Grid>

        <Grid
          item
          lg={6}
          xs={12}
          sm={6}
          md={6}
          sx={{ display: "flex", justifyContent: "center", cursor: "pointer" }}
          onClick={
            reportType["CMM"]?.length > 0
              ? () => {
                dispatch({ type: "moduleType", moduleType: "CMM" });
                // ls.set("moduleType", "CMM")
                onHandler("/app/sebiCmmTracker");
              }
              : undefined
          }
        >
          <LightTooltip
            title={
              !reportType["CMM"]?.length > 0
                ? "You do not have access to CMM. Please contact Admin."
                : ""
            }
            placement="top"
          >
            <div className={moduleLayoutStyles.boxContainer}>
              <img
                src={Analyze}
                alt="CMM Logo"
                className={moduleLayoutStyles.moduleImg}
              />
              <h3 className={moduleLayoutStyles.moduleName}>CMM Module</h3>
            </div>
          </LightTooltip>
        </Grid>
      </Grid>
    </>
  );
};

export default ModulesLayout;